import styled from '@emotion/styled';

import { mq } from '@/utility/mediaQuery';
import { defaultTheme } from '@/utility/theme';

export const Table = styled.table(() =>
  mq({
    width: '100%',
  }),
);

export const TableRow = styled.tr(() =>
  mq({
    border: `solid ${defaultTheme.border.color.black}`,
    borderWidth: '1px 0',
  }),
);

export const TableHeader = styled.th(() =>
  mq({
    width: ['76px', '76px', '130px', '130px'],
    fontSize: [
      defaultTheme.font.size.xs,
      defaultTheme.font.size.xs,
      defaultTheme.font.size.s,
      defaultTheme.font.size.s,
    ],
    fontWeight: 'normal',
    verticalAlign: 'middle',
    textAlign: 'left',
    backgroundColor: defaultTheme.background.mediumGray,
    padding: [
      defaultTheme.spacing.s,
      defaultTheme.spacing.s,
      `${defaultTheme.spacing.m} 0 ${defaultTheme.spacing.m} ${defaultTheme.spacing.m}`,
      `${defaultTheme.spacing.m} 0 ${defaultTheme.spacing.m} ${defaultTheme.spacing.m}`,
    ],
    '& > br': {
      display: ['block', 'block', 'none', 'none'],
    },
  }),
);

export const OtherHeader = styled(TableHeader)(() =>
  mq({
    width: ['151px', '151px', '186px', '186px'],
  }),
);

export const TableData = styled.td(() =>
  mq({
    fontSize: defaultTheme.font.size.s,
    textAlign: 'center',
    verticalAlign: 'middle',
    padding: [
      defaultTheme.spacing.s,
      defaultTheme.spacing.s,
      defaultTheme.spacing.m,
      defaultTheme.spacing.m,
    ],
  }),
);

export const TargetRaceData = styled(TableData)(() =>
  mq({
    color: defaultTheme.text.white,
    fontSize: [
      defaultTheme.font.size.xs,
      defaultTheme.font.size.xs,
      defaultTheme.font.size.s,
      defaultTheme.font.size.s,
    ],
    backgroundColor: defaultTheme.background.secondary,
  }),
);

export const OtherData = styled(TableData)(() =>
  mq({
    fontWeight: 'bold',
    textAlign: 'right',
  }),
);

export const OtherInfoTableWrapper = styled.div(() =>
  mq({
    display: 'grid',
    gridTemplateColumns: [
      'repeat(1, 1fr)',
      'repeat(1, 1fr)',
      'repeat(2, 1fr)',
      'repeat(2, 1fr)',
    ],
    gridGap: [
      0,
      0,
      `0 ${defaultTheme.spacing.l}`,
      `0 ${defaultTheme.spacing.l}`,
    ],
    marginTop: [
      defaultTheme.spacing.l,
      defaultTheme.spacing.l,
      defaultTheme.spacing.xxl,
      defaultTheme.spacing.xxl,
    ],
    '& > table:last-of-type': {
      '& tr:first-of-type': {
        borderWidth: [0, 0, '1px 0', '1px 0'],
      },
    },
  }),
);
